import MemosPage from "./MemosPage";

const routes = [
    {path : 'company/:company/memos', component : () => <MemosPage/>, isSidebar : true, isPublic : false},

]

export default routes;